import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useAsyncAxios, utilAxiosWithAppToken } from "../utils/customAxios";
import { useAuthDispatch } from "../provider/AuthProvider";

import * as Common from "../commons/common";
import * as Request from "../commons/request";
import * as Utils from "../utils/utils";

import styles from "./Welcome.module.css";

declare const window: typeof globalThis & {
    Android: any;
};

function Welcome() {
    const navigate = useNavigate();
    const dispatch = useAuthDispatch();

    const [loginInfo, setLoginInfo] = useState<Common.TypeLogin>();

    useEffect(() => {
        Utils.initModalStack();

        const result = Utils.isPossibleAutoLogin();
        if (result.isPossible && result.email && result.password) {
            setLoginInfo({ email: result.email, password: result.password });
        } else {
            setLoginInfo({ email: "", password: "" });
        }

        window.addEventListener("backPressEvent", onBackPressEvent);
        return () => {
            window.removeEventListener("backPressEvent", onBackPressEvent);
        };
    }, []);

    useEffect(() => {
        if (!loginInfo) return;

        loginInfo.email.length > 0 && loginInfo.password.length > 0 ? login() : navigate(Common.PAGE_LOGIN);
    }, [loginInfo]);

    const requestLogin = async () => {
        const response = await utilAxiosWithAppToken().post(Request.LOGIN_URL, loginInfo);
        return response.data;
    };

    const { error: errorLogin, data: resultLogin, execute: login } = useAsyncAxios(requestLogin);

    useEffect(() => {
        if (!resultLogin) return;

        if (dispatch) {
            dispatch({
                type: "LOGIN_SUCCESS",
                payload: {
                    user: resultLogin.user,
                    token: resultLogin.token,
                },
            });
        }

        navigate(Common.PAGE_MAIN, { replace: true });
    }, [resultLogin]);

    useEffect(() => {
        if (!errorLogin) return;

        navigate(Common.PAGE_LOGIN, { replace: true });
    }, [errorLogin]);

    const onBackPressEvent = () => {
        window.Android.closeAppOnBackPress();
    };

    return <motion.div className={styles.wrapper} exit="exit" />;
}

export default Welcome;
